import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONOS = [{
  num: '01',
  title: 'Kit de Primera Sesión',
  desc: 'Pack imprimible profesional con formularios, apertura y cierre de sesión, checklists y registro completo para comenzar desde el primer día.'
}, {
  num: '02',
  title: 'Diccionario Express de Preguntas Poderosas',
  desc: '120 preguntas organizadas por tipo de conflicto para conducir sesiones con mayor claridad y profundidad.'
}, {
  num: '03',
  title: 'Árbol Bio en 15 Min',
  desc: 'Plantillas listas para imprimir con guía visual y estructura simplificada para detectar patrones familiares rápidamente.'
}, {
  num: '04',
  title: 'Guía de Objeciones y Respuestas',
  desc: 'Las dudas más frecuentes de clientes respondidas de manera clara y profesional para sesiones y WhatsApp.'
}, {
  num: '05',
  title: 'Checklist de Diagnóstico del Terapeuta',
  desc: 'Autoevaluación profesional con plan práctico de mejora para fortalecer habilidades terapéuticas.'
}, {
  num: '06',
  title: 'Sesión Online Pro',
  desc: 'Sistema completo para atender online: mensajes, estructura, cobro, organización y protocolo profesional.'
}];
export function BenefitsSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#EFEAE0] py-5 md:py-10 px-5 sm:px-6 border-t border-[#2E4F48]/5" data-id="element-26">
      <div className="container mx-auto max-w-5xl" data-id="element-27">
        <div ref={ref1} className={`reveal text-center mb-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-28">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#1C3B36]" data-id="element-29">
            Además accedés a{' '}
            <span className="text-[#C2683D] italic" data-id="element-30">6 recursos prácticos</span>{' '}
            exclusivos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-31">
          {BONOS.map((bono, i) => {
          const [ref, vis] = useReveal();
          return <div key={i} ref={ref} className={`reveal bg-[#E8E0D3] border border-[#2E4F48]/10 rounded-xl p-6 transition-all hover:border-[#C2683D]/30 hover:shadow-md ${vis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 60}ms`
          }} data-id="element-32">
                <div className="text-[#C2683D] font-serif font-bold text-3xl mb-3 leading-none" data-id="element-33">
                  {bono.num}
                </div>
                <h3 className="text-[#1C3B36] font-serif font-bold text-lg mb-2 leading-tight" data-id="element-34">
                  {bono.title}
                </h3>
                <p className="text-[#44574F] text-sm leading-relaxed" data-id="element-35">
                  {bono.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}